import { render, staticRenderFns } from "./ClasesDetalleNotasRegistro.vue?vue&type=template&id=c1276bc6&"
import script from "./ClasesDetalleNotasRegistro.vue?vue&type=script&lang=js&"
export * from "./ClasesDetalleNotasRegistro.vue?vue&type=script&lang=js&"
import style0 from "./ClasesDetalleNotasRegistro.vue?vue&type=style&index=0&id=c1276bc6&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports